import React from "react";
import { useTranslation } from "react-i18next";

import { hostedByLogo, mediaByLogo } from "utils/constants/data";

function HostedBy() {
  const { t } = useTranslation();

  const sponsors = {
    hostedBy: (
      <div className="grid items-center grid-cols-3 gap-20 place-items-center app-animation-translate-start">
        {hostedByLogo &&
          hostedByLogo.map((logo, idx) => {
            return (
              <img
                key={idx}
                src={logo && logo.image_url}
                className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain"
                alt={`hosted-by-logo-${idx + 1}`}
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    mediaPartner: (
      <div className="grid items-center grid-cols-1 gap-4 place-items-center app-animation-translate-start">
        {mediaByLogo &&
          mediaByLogo.map((logo, idx) => {
            return (
              <img
                key={idx}
                src={logo && logo.image_url}
                className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain"
                alt={`media-partner-logo-${idx + 1}`}
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
  };

  return (
    <div id="hostedByContainer">
      <section>
        <div className="space-y-8 app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl app-animation-translate-start section-title">
            {t("hostedBy")}
          </p>
          <div className="max-w-2xl mx-auto text-sm sm:text-base">
            {sponsors.hostedBy}
          </div>
        </div>
      </section>
      <section>
        <div className="space-y-8 app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl app-animation-translate-start section-title">
            {t("mediaPartner")}
          </p>
          <div className="max-w-2xl mx-auto text-sm sm:text-base">
            {sponsors.mediaPartner}
          </div>
        </div>
      </section>
    </div>
  );
}

export default HostedBy;
